/**
 * Open a URL in the platform's default browser.
 *
 * Each shell needs its own call:
 *   - Electron: `shell.openExternal` — a plain `window.open` would spawn a
 *     chromeless Electron window instead of the user's browser.
 *   - Capacitor (Android/iOS): the native Browser plugin, so the page opens in
 *     the system browser and not inside the WebView.
 *   - Web: a plain new tab.
 */
import { isElectron, isCapacitor } from '../config/runtime';

export async function openExternalUrl(url: string): Promise<void> {
  if (isElectron()) {
    const electron = window.electron;
    if (electron?.openExternalUrl) {
      await electron.openExternalUrl(url);
      return;
    }
  } else if (isCapacitor()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    } catch {
      // Plugin unavailable — fall through to a normal tab.
    }
  }

  window.open(url, '_blank', 'noopener');
}
